import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Dropdown } from "react-bootstrap";
import { MdFlight, MdFoodBank, MdHotel } from "react-icons/md";
import { FaEnvelope } from "react-icons/fa";
import pkgImg from "../../../images/task/pic4.jpg";
import user from "../../../images/user.jpg";

//images

import RoomSlider from "./Guest/RoomSlider";
import ReactStars from "react-stars";

const DropdownBlog = () => {
  return (
    <>
      <Dropdown className="dropdown dropend ms-auto">
        <Dropdown.Toggle as="div" className="btn-link i-false">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
              stroke="#575757"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item>Edit</Dropdown.Item>
          <Dropdown.Item>Delete</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

const PackageDetails = () => {
  const { packageId } = useParams();
  const [selectBtn, setSelectBtn] = useState("Newest");
  const [travelStatus, setTravelStatus] = useState("All");
  const [loading, setLoading] = useState(false);
  const [packageDetails, setPackage] = useState({
    packageName: "Dubai Tour Package",
    coverImg: "",
    showcaseImg: "",
    price: 149,
    duration: "5 days, 6 nights",
    location: "Dubai",
    facilities: [
      "5 Star Hotel",
      "Selected Meals",
      "Transportation",
      "3 Activities",
    ],
    bookings: [
      {
        id: "ljksdflsdf89093",
        customerId: "klsdfkjlfsd",
        customerName: "John Doe",
        profileImg: "",
        price: 190,
        orderDate: new Date("2024, 12, 12").toDateString(),
        status: "Completed",
        duration: "3 days 4 nights",
        feedback: 4.2,
      },
      {
        id: "ljksdf32289093",
        customerId: "klsdfkjlfsd",
        customerName: "John Doe",
        profileImg: "",
        price: 190,
        orderDate: new Date("2024, 12, 02").toDateString(),
        status: "In Progress",
        duration: "3 days 4 nights",
      },
      {
        id: "ljk2322lsdf89093",
        customerId: "klsdfkjlfsd",
        customerName: "John Doe",
        profileImg: "",
        price: 190,
        orderDate: new Date("2024, 12, 05").toDateString(),
        status: "Cancelled",
        duration: "3 days 4 nights",
      },
    ],
  });

  // Add a derived state for filtered and sorted bookings
  const filteredBookings = packageDetails.bookings
    .filter((booking) => {
      // Filter based on travel status
      const matchesStatus =
        travelStatus === "All" ||
        booking.status.toLowerCase() === travelStatus.toLowerCase();
      return matchesStatus;
    })
    .sort((a, b) => {
      // Sort by orderDate based on selectBtn value
      if (selectBtn === "Newest") {
        return new Date(b.orderDate) - new Date(a.orderDate); // Descending order
      } else if (selectBtn === "Oldest") {
        return new Date(a.orderDate) - new Date(b.orderDate); // Ascending order
      }
      return 0; // Default no sorting
    });

  const getPackageDetails = async () => {
    setLoading(true);
    const response = {
      status: 200,
      data: {
        packageName: "Dubai Tour Package",
        coverImg: "",
        showcaseImg: "",
        price: 149,
        duration: "5 days, 6 nights",
        location: "Dubai",
        facilities: [
          "5 Star Hotel",
          "Selected Meals",
          "Transportation",
          "3 Activities",
        ],
        bookings: [
          {
            id: "ljksdflsdf89093",
            customerId: "klsdfkjlfsd",
            customerName: "John Doe",
            profileImg: "",
            price: 190,
            orderDate: new Date("2024, 12, 12").toDateString(),
            status: "Completed",
            duration: "3 days 4 nights",
            feedback: 4.2,
          },
          {
            id: "ljksdf32289093",
            customerId: "klsdfkjlfsd",
            customerName: "John Doe",
            profileImg: "",
            price: 190,
            orderDate: new Date("2024, 12, 02").toDateString(),
            status: "In Progress",
            duration: "3 days 4 nights",
          },
          {
            id: "ljk2322lsdf89093",
            customerId: "klsdfkjlfsd",
            customerName: "John Doe",
            profileImg: "",
            price: 190,
            orderDate: new Date("2024, 12, 05").toDateString(),
            status: "Cancelled",
            duration: "3 days 4 nights",
          },
        ],
      },
    }; // axios.post()
    if (response.status === 200) {
      setPackage({ ...response.data });
    }
    setLoading(false);
  };

  useEffect(() => {
    getPackageDetails();
  }, [packageId]);

  return (
    <>
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="card overflow-hidden">
                  <div className="row m-0">
                    <div className="col-xl-6 p-0">
                      <div className="card-body">
                        <div className="guest-profile">
                          <div className="d-flex items-c">
                            <img
                              src={packageDetails.coverImg || pkgImg}
                              alt=""
                              className="my-auto"
                            />
                            <div>
                              <h2 className="font-w600">
                                {packageDetails.packageName}
                              </h2>
                              <h5>
                                <strong>Price: </strong>${packageDetails.price}
                              </h5>
                              <h5>
                                <strong>Duration: </strong>
                                <span>{packageDetails.duration}</span>
                              </h5>
                              <h5>
                                <strong>Location: </strong>
                                <span>{packageDetails.location}</span>
                              </h5>
                            </div>
                            <DropdownBlog />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="flex flex-col gap-y-3 mt-3"></div>
                          <div className="facilities">
                            <h4 className="d-block mb-3">Facilities</h4>
                            <div className="mb-3 grid grid-cols-2">
                              <Link
                                to={"#"}
                                className="btn btn-secondary light btn-lg"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  className="flex justify-center mr-2"
                                  style={{
                                    fontSize: "22px",
                                    textAlign: "center",
                                  }}
                                >
                                  <MdHotel />
                                </span>
                                5 Star Hotel
                              </Link>
                              <Link
                                to={"#"}
                                className="btn btn-secondary light btn-lg text-center"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  className="flex justify-center mr-2"
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                  }}
                                >
                                  <MdFlight />
                                </span>
                                Round Trip Flights
                              </Link>
                              <Link
                                to={"#"}
                                className="btn btn-secondary light btn-lg text-center"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  className="flex justify-center mr-2"
                                  style={{
                                    fontSize: "25px",
                                    textAlign: "center",
                                  }}
                                >
                                  <MdFoodBank />
                                </span>
                                Selected Meals
                              </Link>
                            </div>
                            {packageDetails.facilities.map((facility) => (
                              <Link
                                to={"#"}
                                className="btn btn-secondary light"
                                key={facility}
                              >
                                {facility}
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 p-0">
                      <RoomSlider />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header border-0">
                  <h4 className="fs-20">Booking History</h4>
                  <div className="flex flex-row gap-x-2">
                    <div className="newest ms-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          as="div"
                          className=" btn-select-drop default-select btn i-false"
                        >
                          {travelStatus}{" "}
                          <i className="fas fa-angle-down ms-2 "></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setTravelStatus("All")}>
                            All
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTravelStatus("Cancelled")}
                          >
                            Cancelled
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTravelStatus("In Progress")}
                          >
                            In Progress
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTravelStatus("Completed")}
                          >
                            Completed
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="newest ms-3">
                      {/* <select className="default-select">
											<option>Newest</option>
											<option>Oldest</option>
										</select> */}
                      <Dropdown>
                        <Dropdown.Toggle
                          as="div"
                          className=" btn-select-drop default-select btn i-false"
                        >
                          {selectBtn}{" "}
                          <i className="fas fa-angle-down ms-2 "></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setSelectBtn("Oldest")}>
                            Oldest
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setSelectBtn("Newest")}>
                            Newest
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0 table-responsive">
                  <table className="table w-full">
                    <thead className="text-start">
                      <tr>
                        <th className="w-[35%]">Customer</th>
                        <th className="w-[15%]">Status</th>
                        <th className="w-[10%]">Booking Date</th>
                        <th className="w-[5%]">Total Cost</th>
                        <th className="w-[20%]">Feedback</th>
                        {/* <th className="w-[5%]">Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredBookings.map((booking) => (
                        <tr key={booking.id} className="w-full">
                          <td className="w-[35%]">
                            <div className="flex flex-col xl:flex-row align-items-center">
                              <img
                                src={booking.profileImg || user}
                                alt=""
                                className="w-[100px] rounded-lg me-2"
                              />
                              <div className="flex flex-col gap-y-2">
                                <Link
                                  to={`/customer-details/${booking.customerId}`}
                                  className="text-lg text-black"
                                >
                                  {booking.customerName}
                                </Link>
                                <span className="fs-12">
                                  Duration: {booking.duration}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="text-black my-auto h-full w-[15%]">
                            <span className="fs-18 font-w500">
                              {booking.status}
                            </span>
                          </td>
                          <td className="text-black my-auto h-full w-[10%]">
                            <span className="fs-18 font-w500">
                              {booking.orderDate}
                            </span>
                          </td>
                          <td className="text-black my-auto h-full w-[5%]">
                            <span className="fs-18 font-w500">
                              ${booking.price}
                            </span>
                          </td>
                          <td className="text-black my-auto h-full w-[20%]">
                            {booking.feedback && (
                              <ReactStars
                                value={booking.feedback}
                                count={5}
                                size={24}
                                color2={"#ffd700"}
                                className="w-full"
                              />
                            )}
                          </td>
                          {/* <td className="text-black my-auto h-full w-[5%]">
                            <DropdownBlog />
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PackageDetails;
